// extracted by mini-css-extract-plugin
export default {"restricted":"Form_restricted__VF8kk"};